import type { LucideIcon } from 'lucide-react';

export type FilterType = 'workspace' | 'version_group' | 'user';

export type FilterOperator = 'is' | 'is_not' | 'is_any_of' | 'is_not_any_of';

export const FILTER_OPERATORS: {
  value: FilterOperator;
  label: string;
  multi: boolean;
}[] = [
  { value: 'is', label: 'is', multi: false },
  { value: 'is_not', label: 'is not', multi: false },
  { value: 'is_any_of', label: 'is any of', multi: true },
  { value: 'is_not_any_of', label: 'is not any of', multi: true }
];

export const DEFAULT_OPERATOR: FilterOperator = 'is_any_of';

export const isMultiOperator = (op: FilterOperator): boolean =>
  op === 'is_any_of' || op === 'is_not_any_of';

export const isNegatedOperator = (op: FilterOperator): boolean =>
  op === 'is_not' || op === 'is_not_any_of';

export type FilterDefinition = {
  type: FilterType;
  label: string;
  icon: LucideIcon;
  paramKey: string;
};

export type FilterState = {
  values: string[];
  operator: FilterOperator;
};

export type GenerationFilters = {
  workspace_id: FilterState;
  version_group: FilterState;
  created_by: FilterState;
};

/** Param keys used in the URL */
export const FILTER_PARAM_KEYS = {
  workspace: 'workspace_id',
  version_group: 'version_group',
  user: 'created_by'
} as const;

/** Operator param keys in the URL (e.g., workspace_id_op=is_not) */
export const OPERATOR_PARAM_KEYS = {
  workspace: 'workspace_id_op',
  version_group: 'version_group_op',
  user: 'created_by_op'
} as const;
